<div *ngIf="user">
    <div class="row">
        <div class="col">
            <div class="form-group form-inline">
                <input class="form-control" type="text" [formControl]="searchTermControl" placeholder="Rechercher" />
                <select class="form-control ml-2" [formControl]="sessionFilterControl">
                    <option value="all" default>Toutes les sessions</option>
                    <option *ngFor="let session of sessions" [value]="session.id">
                        {{session.code}}
                    </option>
                </select>
                <select *ngIf="user.isCorrector" class="form-control ml-2" [formControl]="correctorFilterControl">
                    <option value="corrector_all" default>Toutes les corrections</option>
                    <option value="corrector_1">En tant que correcteur principal</option>
                    <option value="corrector_2">En tant que correcteur secondaire</option>
                </select>
            </div>
        </div>
        <div class="col">
            <ngb-pagination (pageChange)="onPageChange($event)" [page]="page" [pageSize]="pageSize"
                [collectionSize]="itemsCount"></ngb-pagination>
        </div>
        <div class="col d-flex flex-column align-items-end">
            <div class="d-flex justify-content-end">
                <button class="btn btn-link" (click)="add()" *ngIf="user.isStaff">
                    <i class="fas fa-plus"></i>
                    Ajouter de nouveaux codes
                </button>
                <button class="btn btn-link" (click)="request()" *ngIf="user.isExamCenterBoss">
                    <i class="fas fa-plus"></i>
                    Demander de nouveaux codes
                </button>
            </div>
            <button class="btn btn-link btn-sm p-0" [ngClass]="voucherRequestsLabelClass"
                (click)="openVoucherRequestsModal()"
                *ngIf="user.isExamCenterBoss">
                {{ voucherRequestsLabel }}
            </button>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col">
            <div class="d-flex flex-wrap" style="gap: 0.5rem;" role="group">
                <button type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-primary]="studentFilterControl.value === 'all'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'all'"
                        (click)="setStudentFilter('all')">
                    Tous ({{ statusCounts.total }})
                </button>
                <button *ngIf="!user.isCorrector"
                        type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-secondary]="studentFilterControl.value === 'free'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'free'"
                        (click)="setStudentFilter('free')">
                    Libre ({{ statusCounts.free }})
                </button>
                <button *ngIf="!user.isCorrector"
                        type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-warning]="studentFilterControl.value === 'waiting'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'waiting'"
                        (click)="setStudentFilter('waiting')">
                    En attente ({{ statusCounts.waiting }})
                </button>
                <button *ngIf="!user.isCorrector"
                        type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-info]="studentFilterControl.value === 'assigned'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'assigned'"
                        (click)="setStudentFilter('assigned')">
                    Attribué ({{ statusCounts.assigned }})
                </button>
                <button type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-danger]="studentFilterControl.value === 'to_check'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'to_check'"
                        (click)="setStudentFilter('to_check')">
                    A vérifier ({{ statusCounts.to_check }})
                </button>
                <button type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-danger]="studentFilterControl.value === 'to_correct'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'to_correct'"
                        (click)="setStudentFilter('to_correct')">
                    A corriger ({{ statusCounts.to_correct }})
                </button>
                <button type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-warning]="studentFilterControl.value === 'to_validate'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'to_validate'"
                        (click)="setStudentFilter('to_validate')">
                    A valider ({{ statusCounts.to_validate }})
                </button>
                <button type="button"
                        class="btn btn-sm rounded-pill"
                        style="white-space: nowrap;"
                        [class.btn-success]="studentFilterControl.value === 'closed'"
                        [class.btn-outline-secondary]="studentFilterControl.value !== 'closed'"
                        (click)="setStudentFilter('closed')">
                    Clôturés ({{ statusCounts.closed }})
                </button>
            </div>
        </div>
    </div>
</div>

<app-loading-overlay [active]="loading">
    <table class="table table-striped" *ngIf="user">
        <thead>
            <tr>
                <ng-container>
                    <th scope="col" *ngIf="user.isCorrector"></th>
                    <th scope="col"
                        *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor || user.isCorrector">
                        Code</th>
                    <th scope="col"
                        *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor || user.isCorrector">
                        Session</th>
                    <th scope="col" *ngIf="user.isStaff">Centres</th>
                    <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">Certification
                    </th>
                    <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">Candidat</th>
                    <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss">Succès</th>
                    <th scope="col" *ngIf="user.isStaff || user.isSupervisor || user.isCorrector">
                        Fichiers
                    </th>
                    <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss">Facture</th>
                    <th scope="col" *ngIf="user.isStaff">Diplôme</th>
                    <th scope="col" *ngIf="user.isCorrector || user.isStaff">Correction</th>
                    <th scope="col"
                        *ngIf="user.isCorrector || user.isStaff || user.isSupervisor || user.isExamCenterBoss">
                        <i class="fas fa-comment">
                        </i>
                    </th>
                    <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss">
                        Status
                    </th>
                    <th scope="col">Actions</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let exam of exams; index as i">

                <!-- Corrector is main or not -->

                <td *ngIf="user.isCorrector">
                    <i *ngIf="exam.isMainCorrector" class="fas fa-star"></i>
                </td>

                <!-- Voucher code -->

                <td *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor || user.isCorrector">
                    <i class="fas fa-hashtag" style="margin-right: 5px;"></i>
                    <ngb-highlight [result]="exam.voucher_code" [term]="searchTermControl.value"></ngb-highlight>

                    <ng-container *ngIf="(user.isStaff || user.isExamCenterBoss) && exam.file_number">
                        <br>
                        <i class="fas fa-folder" style="margin-right: 5px;"></i>
                        <ngb-highlight [result]="exam.file_number" [term]="searchTermControl.value"></ngb-highlight>
                    </ng-container>
                </td>

                <!-- Session -->

                <td *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor || user.isCorrector">
                    <ng-container
                        *ngIf="!exam.session && (!user.isExamCenterBoss || exam.exam_center.boss_id == user.id)">
                        <span class="btn-assign text-secondary " (click)="openSelectSessionModal(exam)">
                            En attente d'attribution
                        </span>
                    </ng-container>
                    <ng-container *ngIf="exam.session">
                        <span class="btn btn-link" (click)="openSessionModal(exam.session)">
                            <ngb-highlight [result]="exam.session.code" [term]="searchTermControl.value">
                            </ngb-highlight>
                        </span>
                    </ng-container>
                </td>

                <!-- Formation and exam centers -->

                <td *ngIf="user.isStaff">
                    <div style="display: flex; align-items: center;">
                        <i class="fas fa-school" style="margin-right: 5px;"></i>
                        <ng-container *ngIf="!exam.invoice">
                            En attente d'attribution
                        </ng-container>
                        <ng-container *ngIf="exam.invoice">
                            <ngb-highlight [result]="exam.invoice.center.nom" [term]="searchTermControl.value">
                            </ngb-highlight>
                        </ng-container>
                    </div>

                    <div style="display: flex; align-items: center;">
                        <i class="fas fa-graduation-cap" style="margin-right: 5px;"></i>
                        <ng-container *ngIf="exam.exam_center">
                            <ngb-highlight [result]="exam.exam_center.nom" [term]="searchTermControl.value">
                            </ngb-highlight>
                        </ng-container>
                    </div>
                </td>

                <!-- Certification -->

                <td *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">
                    <ng-container
                        *ngIf="!exam.certification  && (!user.isExamCenterBoss || exam.exam_center.boss_id == user.id)">
                        <span class="btn-assign text-secondary" (click)="openSelectCertificationModal(exam)">
                            En attente d'attribution
                        </span>
                    </ng-container>
                    <ngb-highlight *ngIf="exam.certification" [result]="exam.certification.title"
                        [term]="searchTermControl.value"></ngb-highlight>
                </td>

                <!-- Student -->

                <td *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">

                    <!-- Cas 1 : candidat inscrit -->
                    <ng-container *ngIf="exam.student">
                        <button *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor" class="btn btn-link"
                            (click)="openStudentModal(exam)">
                            <i *ngIf="exam.student.student_profile && exam.student.student_profile.psh" class="fas fa-wheelchair"
                                style="margin-right: 5px;"></i>
                            <ngb-highlight [result]="exam.student.fullName" [term]="searchTermControl.value">
                            </ngb-highlight>
                        </button>

                        <ngb-highlight *ngIf="!user.isStaff && !user.isExamCenterBoss && !user.isSupervisor"
                            [result]="exam.student.fullName" [term]="searchTermControl.value">
                        </ngb-highlight>
                    </ng-container>

                    <!-- Cas 2 : convocation envoyée, candidat pas encore inscrit -->
                    <ng-container *ngIf="!exam.student && exam.preregistration && (!user.isExamCenterBoss || exam.exam_center.boss_id == user.id)">
                        <span class="text-muted font-italic">
                            <i class="fas fa-envelope" style="margin-right: 4px;"></i>Convoqué
                        </span>
                        <br>
                        <button class="btn btn-link btn-sm p-0" (click)="openSelectStudentModal(exam)">
                            <i class="fas fa-exchange-alt" style="margin-right: 4px;"></i>Réattribuer
                        </button>
                    </ng-container>

                    <!-- Cas 3 : ticket libre, aucune pré-inscription -->
                    <ng-container *ngIf="!exam.student && !exam.preregistration && (!user.isExamCenterBoss || exam.exam_center.boss_id == user.id)">
                        <button class="btn btn-link btn-sm p-0" (click)="openSelectStudentModal(exam)">
                            <i class="fas fa-user-plus" style="margin-right: 4px;"></i>Attribuer
                        </button>
                    </ng-container>

                </td>

                <!-- Success -->

                <td *ngIf="user.isStaff">
                    <span *ngIf="exam.success == true" class="text-success">
                        <i class="fas fa-check"></i>
                        <span *ngIf="!exam.locked">
                            (En attente de validation)
                        </span>
                    </span>
                    <span *ngIf="exam.success == false" class="text-danger">
                        <i class="fas fa-times"></i>
                        <span *ngIf="!exam.locked">
                            (En attente de validation)
                        </span>
                    </span>
                    <span *ngIf="exam.success == null">-</span>
                </td>

                <td *ngIf="user.isExamCenterBoss">
                    <a *ngIf="exam.success == true && exam.locked == true" class="text-success" style="cursor: pointer;"
                        (click)="openExamResultsModal(exam)">
                        <i class="fas fa-check"></i>
                        Examen réussi
                    </a>
                    <a *ngIf="exam.success == false && exam.locked == true" class="text-danger" style="cursor: pointer;"
                        (click)="openExamResultsModal(exam)">
                        <i class="fas fa-times"></i>
                        Examen échoué
                    </a>
                    <span *ngIf="exam.locked != true || (exam.success != false && exam.success != true)">
                        <span class="text-secondary">Non disponible</span>
                    </span>
                </td>

                <!-- Exam result files -->

                <td *ngIf="user.isStaff || user.isSupervisor  || user.isCorrector">
                    <button *ngIf="!user.isCorrector" class="btn btn-link"
                        style="display: flex; justify-content: center; align-items: center;"
                        (click)="openFilesModal(exam)" [disabled]="!exam.session">
                        <div *ngIf="exam.examResultFiles && exam.examResultFiles.length">
                            <i class="fas fa-file" style="margin-right: 5px;"></i>
                            {{ exam.examResultFiles.length }}
                        </div>

                        <div *ngIf="!(exam.examResultFiles && exam.examResultFiles.length)">
                            <i class="fas fa-file-upload"></i>
                        </div>
                    </button>

                    <ng-container *ngIf="user.isCorrector">
                        <button *ngIf="exam.examResultFiles && exam.examResultFiles.length" class="btn btn-link"
                            style="display: flex; justify-content: center; align-items: center;"
                            (click)="openFilesModal(exam)">
                            <i class="fas fa-file" style="margin-right: 5px;"></i>
                            {{exam.examResultFiles.length}}
                        </button>

                        <span *ngIf="!(exam.examResultFiles && exam.examResultFiles.length)">En attente des
                            fichiers</span>
                    </ng-container>
                </td>

                <!-- Facture -->

                <td *ngIf="user.isStaff || user.isExamCenterBoss">
                    <ng-container *ngIf="!exam.invoice">-</ng-container>
                    <button *ngIf="exam.invoice && exam.invoice.document" class="btn btn-link" (click)="showInvoiceDocument(exam)"
                        [disabled]="retrievingInvoiceDocumentForExamId == exam.id">
                        <span *ngIf="retrievingInvoiceDocumentForExamId == exam.id" class="button-loader"></span>
                        {{ exam.invoice.label }}
                    </button>
                </td>

                <!-- Diploma -->

                <td *ngIf="user.isStaff">
                    <ng-container *ngIf="!exam.diplome">
                        <span *ngIf="!user.isStaff"> - </span>
                        <button *ngIf="user.isStaff" class="btn btn-link " (click)="openDiplomeModal(exam)"
                            [disabled]="!exam.session">
                            <i class="fas fa-file-upload"></i>
                        </button>
                    </ng-container>
                    <a target="_blank" rel="noopener noreferrer" class="btn btn-link" *ngIf="exam.diplome"
                        [href]="exam.diplome">
                        <i class="fas fa-eye"></i>
                    </a>
                </td>

                <!-- Correction -->

                <td *ngIf="user.isCorrector || user.isStaff">
                    <ng-container *ngIf="exam.locked">
                        <button class="btn btn-link text-success" (click)="openCorrectionModal(exam)">
                            <i class="fas fa-lock"></i>
                            Résultats confirmés
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!exam.locked">
                        <ng-container *ngIf="exam.isCorrected">
                            <button class="btn btn-link" (click)="openCorrectionModal(exam)" *ngIf="!user.isCorrector">
                                Valider la correction
                            </button>
                            <button *ngIf="user.isCorrector" (click)="openCorrectionModal(exam)" class="btn btn-link">
                                <i class="fas fa-check"></i>&nbsp;Résultats saisis</button>
                        </ng-container>
                        <ng-container *ngIf="!exam.isCorrected">
                            <span *ngIf="!user.isCorrector">
                                Correction en attente
                            </span>
                            <button [disabled]="!exam.canBeCorrected" class="btn btn-link"
                                (click)="openCorrectionModal(exam)" *ngIf="user.isCorrector">
                                Saisir les résultats
                            </button>
                        </ng-container>
                    </ng-container>
                </td>

                <!-- Comments -->

                <td *ngIf="user.isStaff || user.isSupervisor || user.isCorrector || user.isExamCenterBoss">
                    <div style="display: flex; align-items: center;">
                        <button class="btn btn-link" style="display: flex; justify-content: center; align-items: center;"
                            (click)="openExamCommentsModal(exam)">
                            <i class="fas fa-comment" style="margin-right: 5px;"></i>
                            {{ exam.comments.length }}
                        </button>

                        <!-- Un badge par catégorie et par jour, empilés du plus critique au moins critique puis du jour le plus récent
                             au plus ancien ; dans une catégorie, les jours supplantés par un plus récent sont en transparence -->
                        <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 3px; margin-left: 5px;">
                            <ng-container *ngFor="let badge of exam.commentBadges">
                                <span class="badge" [ngClass]="badge.badgeClass" [class.comment-badge--obsolete]="badge.obsolete"
                                    [ngbTooltip]="badgeTooltip"
                                    container="body" tooltipClass="comment-tooltip">
                                    {{ badge.label }}<ng-container *ngIf="badge.count > 1">&nbsp;×{{ badge.count }}</ng-container>
                                </span>

                                <!-- Messages du groupe, du plus récent au plus ancien comme dans la modale -->
                                <ng-template #badgeTooltip>
                                    <div *ngFor="let comment of badge.comments" class="comment-tooltip__entry">
                                        <span class="comment-tooltip__date">
                                            {{ comment.created_date | date:'dd/MM/yyyy' }}
                                        </span>
                                        {{ comment.comment }}
                                    </div>
                                </ng-template>
                            </ng-container>
                        </div>
                    </div>
                </td>

                <!-- Status -->

                <td *ngIf="user.isStaff || user.isExamCenterBoss">
                    <button class="btn btn-link" style="display: flex; justify-content: center; align-items: center;"
                        (click)="openExamHistoryModal(exam)">
                        {{ exam.getStatus() }}
                    </button>
                </td>

                <!-- Edit -->

                <td>
                    <div style="display: flex; flex-direction: column;">
                        <button class="btn btn-link" (click)="edit(exam)" [disabled]="!exam.canBeReset">
                            <i class="fas fa-edit"></i>
                            Modifier
                        </button>

                        <button *ngIf="user.isStaff || user.isExamCenterBoss" class="btn btn-link"
                            (click)="reschedule(exam)" [disabled]="!exam.canBeRescheduled">
                            <i class="fas fa-calendar-alt"></i>
                            Replanifier
                        </button>

                        <button *ngIf="user.isStaff" class="btn btn-link" style="color: red;"
                            (click)="openExamResetConfirmModal(exam)" [disabled]="!exam.canBeReset">
                            <i class="fas fa-rotate-left"></i>
                            Réinitialiser
                        </button>

                        <button *ngIf="user.isStaff || user.isExamCenterBoss"
                            [disabled]="!exam.session || !exam.session.wasOpen" class="btn btn-link"
                            (click)="certificatePdf(exam)">
                            <i class="fas fa-download"></i>
                            Attestation de passage
                        </button>
                    </div>
                </td>
            </tr>


        </tbody>
    </table>
</app-loading-overlay>
